import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss'],
    standalone: false
})
export class AlertComponent implements OnInit {
    @Input() text: string = '';
    @Input() icon: string = '';
    @Input() inline: boolean = false;
    @Input() typeClass: 'alert--warning' = 'alert--warning';

    @Output() dismiss = new EventEmitter();

    hidden: boolean = false;

    constructor() {}

    ngOnInit(): void {}
}
